import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import StatusIndicator from "@cloudscape-design/components/status-indicator";
import { navigate } from "../../router/useRoute";
import { PublicShell } from "./PublicShell";

interface Props {
  title: string;
  detail: string;
  actionLabel: string;
  actionHref: string;
  status?: "success" | "error";
}

/** Trạng thái kết thúc của các luồng gửi email: đăng ký, quên mật khẩu, xác minh. */
export function ResultPage({ title, detail, actionLabel, actionHref, status = "success" }: Props) {
  return (
    <PublicShell title={title}>
      <SpaceBetween size="l">
        <StatusIndicator type={status}>{detail}</StatusIndicator>
        <Box>
          <Button variant="primary" href={actionHref} onFollow={(event) => {
            event.preventDefault();
            navigate(actionHref);
          }}>
            {actionLabel}
          </Button>
        </Box>
      </SpaceBetween>
    </PublicShell>
  );
}
